import { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import modalStyles from '~styles/modalStyles.scss';
import buttonStyles from '~styles/buttonStyles.scss';
import { cancelOrderAndFetchTasks, closeModal } from '~actions/transferActions';

import { Button, Textarea } from '~ui-kit';

const defaultModalTxt = 'Haluatko varmasti perua tämän tilauksen?';

// uses react-bootstrap modal..
const MessageModal = ({
  modalTxt = defaultModalTxt,
  showConfirmationModal,
  selectedOrderId,
  cancelOrderAndFetchTasks,
  closeModal,
}) => {
  const [cancelReason, setCancelReason] = useState('');
  const valid = cancelReason?.length > 0;

  const closeAndReset = () => {
    closeModal();
    setCancelReason('');
  };

  const cancelOrder = () => {
    if (!valid) return;
    cancelOrderAndFetchTasks(selectedOrderId, cancelReason);
    setCancelReason('');
  };

  return (
    <Modal show={showConfirmationModal}>
      <Modal.Body>
        <p className={modalStyles.askede}>{modalTxt}</p>
        <Textarea
          value={cancelReason}
          onChange={value => setCancelReason(value)}
        />
        <Buttons
          cancelOrderAndFetchTasks={cancelOrder}
          closeModal={closeAndReset}
          valid={valid}
        />
      </Modal.Body>
    </Modal>
  );
};

const Buttons = ({ cancelOrderAndFetchTasks, closeModal, valid }) => (
  <ButtonContainer>
    <Button
      secondary
      type="submit"
      disabled={!valid}
      className={buttonStyles.submitFormButton}
      onClick={cancelOrderAndFetchTasks}
    >
      Peru tilaus
    </Button>
    <Button
      type="button"
      className={buttonStyles.cancelFormButton}
      onClick={() => closeModal()}
    >
      Palaa
    </Button>
  </ButtonContainer>
);

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;

  & > button {
    width: 50%;
  }
`;

export default connect(
  state => ({
    showConfirmationModal: state.transferReducers.showConfirmationModal,
    selectedOrderId: state.transferReducers.selectedOrderId,
  }),
  { cancelOrderAndFetchTasks, closeModal }
)(MessageModal);
